module.exports = __webpack_public_path__ + "media/images/shared/logotypes/logo_ale-2af1ff4cfc0124f450bc69c79648b158.png";